const getUserName = (
  user,
  displayName = 'real_name',
  displayLastName = 'display',
  options = {}
) => {
  try {
    const {
      usernameKey = 'username',
      firstNameKey = 'first_name',
      lastNameKey = 'last_name',
    } = options

    if (displayName === 'real_name') {
      const lastName =
        displayLastName !== 'display' ? `${user[lastNameKey][0]}.` : user[lastNameKey]

      return `${user[firstNameKey]} ${lastName}`
    }

    if (!user[usernameKey]) {
      return `${user[firstNameKey] || ''} ${user[lastNameKey] || ''}`
    }

    return user[usernameKey]
  } catch (e) {
    console.log(e)
    return ''
  }
}

export default getUserName
